import { FC } from 'react';
import { sanitize } from 'isomorphic-dompurify';
import Head from 'next/head';

import { ParsedNode } from '@gn-audio/jss-components';

export interface TopSectionProps {
  nodes?: ParsedNode[];
}

export const TopSection: FC<TopSectionProps> = ({ nodes }) => {
  if (!nodes) return null;

  return (
    <Head>
      {nodes.map((node, idx) => {
        const { tagName, content, props } = node;
        switch (tagName) {
          case 'meta':
            return <meta key={`${tagName}_${idx}`} {...props} />;
          case 'link':
            return <link key={`${tagName}_${idx}`} {...props} />;
          case 'style':
            return (
              <style
                key={`${tagName}_${idx}`}
                {...props}
                dangerouslySetInnerHTML={{ __html: sanitize(content ?? '') }}
              />
            );
          default:
            return null;
        }
      })}
    </Head>
  );
};
